import type { SVGProps } from 'react'
const SvgSyPinAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M4.379 17.574C3.556 18.077 3 18.724 3 19.5s.556 1.423 1.379 1.926 1.94.89 3.271 1.162S10.477 23 12 23s3.019-.14 4.35-.412 2.448-.66 3.271-1.162C20.444 20.923 21 20.276 21 19.5s-.556-1.423-1.379-1.926a.5.5 0 0 0-.685.164.5.5 0 0 0 .164.688c.669.409.9.796.9 1.074s-.231.665-.9 1.074c-.67.41-1.696.778-2.95 1.033-1.253.256-2.689.393-4.15.393s-2.897-.137-4.15-.393c-1.254-.255-2.28-.624-2.95-1.033-.669-.409-.9-.796-.9-1.074s.231-.665.9-1.074a.5.5 0 0 0 .164-.688.5.5 0 0 0-.685-.164"
		/>
		<path
			fillOpacity={0.24}
			d="M19 10c0 5.016-5.119 8.035-6.602 8.804a.86.86 0 0 1-.796 0C10.119 18.034 5 15.016 5 10a7 7 0 0 1 14 0"
		/>
		<circle cx={12} cy={10} r={3} />
	</svg>
)
export default SvgSyPinAlt
